export default {
  title: '字典管理',
  category: '字典分类',
  item: '字典项',
  categoryName: '分类名称',
  categoryCode: '分类代码',
  itemCode: '项代码',
  itemName: '项名称',
  sortOrder: '排序',
  enabled: '启用',
  biz_order_status: '业务委托状态',
  cargo_type: '货物类型',
  currency: '币种',
  customer_source: '客户来源',
  customer_type_biz: '客户类型-业务',
  customer_type_entry: '客户类型-录入',
  issuing_airline: '签发航司',
  legal_entity_relation: '法人关系',
  pallet_type: '板位类型',
  product_type: '产品类型',
  region: '区域',
  surcharge_type: '附加费类型',
  transport_mode: '运输方式',
  AREA: '目的区域',
}
